import React from 'react';
import { cn } from '@/lib/utils';

/**
 * KpiCard displays a single metric with an optional trend indicator and icon.
 * It can be clickable or static. Use within the KpiRibbon.
 */
export interface KpiCardProps {
  title: string;
  value: string | number;
  delta?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export const KpiCard: React.FC<KpiCardProps> = ({ title, value, delta, icon, onClick, className }) => {
  const Component = onClick ? 'button' : 'div';
  
  return (
    <Component
      onClick={onClick}
      className={cn(
        'relative flex flex-col justify-between p-4 rounded-lg bg-surface text-fg shadow hover:shadow-md focus:outline-none focus:ring-2 focus:ring-accent transition duration-150',
        onClick && 'cursor-pointer',
        className,
      )}
    >
      <div className="flex items-center space-x-2 mb-2">
        {icon && <div className="text-accent h-5 w-5 flex-shrink-0">{icon}</div>}
        <span className="text-sm font-medium text-muted truncate">{title}</span>
      </div>
      <div className="flex items-baseline space-x-2">
        <span className="text-2xl font-semibold leading-none text-fg">{value}</span>
        {delta && <span className="text-xs text-success">{delta}</span>}
      </div>
    </Component>
  );
};

export default KpiCard;

